module.exports = __webpack_public_path__ + "static/img/application8-1.d22bacd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application8-1.jpg
// module id = UIWI
// module chunks = 0